var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_USER = 'api/user';
const DRIVERS_APP_PUSH_TOKEN_ENDPOINT = 'api/driversapp/users/me/push-token';
const REQUEST_PARAMS = {
    token: 'LOGGED_USER_TOKEN',
};
export const updateUserById = function (userId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_USER}/${userId}`, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error fetching updateUserById:', error);
            throw error;
        }
    });
};
export const updatePushNotificationTokenDriversApp = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.put(DRIVERS_APP_PUSH_TOKEN_ENDPOINT, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error updating drivers app push notification token:', error);
            throw error;
        }
    });
};
